var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center flex-column text-center"},[_c('a',{staticClass:"btn-skip pt-3 pl-3",on:{"click":_vm.skip}},[_vm._v("דלג")]),_c('h5',[_vm._v("הורדה מהירה בחינם")]),_c('icon',{staticClass:"w-100 mx-auto mt-4 mb-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }